import { type FloatingContentAlignment, type StylableProps, AutoTooltip, Icon } from "@mdotm/shadcn/legacy/components";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import { useCallback, type ReactNode } from "react";

export type InfoTooltipProps = { children: ReactNode; align?: FloatingContentAlignment } & StylableProps;

export function InfoTooltip({ children, style, className, align }: InfoTooltipProps): React.JSX.Element {
	const trigger = useCallback(
		({ innerRef }: { innerRef: (instance: HTMLElement | null) => void }) => (
			<Icon
				innerRef={innerRef}
				icon="Information"
				color={themeCSSVars.palette_N500}
				size={20}
				className={className}
				style={style}
			/>
		),
		[className, style],
	);
	return (
		<AutoTooltip
			severity="success"
			overrideColor="white"
			trigger={trigger}
			position="top"
			align={align ?? "endToStart"}
		>
			{children}
		</AutoTooltip>
	);
}
